import { validate as validateEmail } from 'email-validator';

import { TXTCLI_Email_address_is_not_valid } from '../translations';
import type { Error } from '../types';
import { RESTRICTED_SYMBOLS_SHORT } from '../utils/regex';

export const email = (value: string): Error => ({
  valid: !!value && validateEmail(value) && !RESTRICTED_SYMBOLS_SHORT.test(value),
  message: TXTCLI_Email_address_is_not_valid
});
